function ProcessRequest() {
    this.__type = 'ProcessRequest:www.veritracks.com';
    this.Id = -1;
    this.EnrolleeId = -1;
    this.OrganizationId = -1;
    this.OffenderPayFlag = false;
    this.DailyRate = -1;
    this.Action = "";
}
if (typeof exports !== 'undefined') {
    module.exports = ProcessRequest;
}